import { useEffect } from "react";

const useUserActivity = (onActive: () => void) => {
  useEffect(() => {
    const handleActivity = () => {
      onActive();
    };

    // User becomes active again
    window.addEventListener("focus", handleActivity);

    // User interacts (optional but recommended)
    window.addEventListener("mousemove", handleActivity);
    window.addEventListener("keydown", handleActivity);
    window.addEventListener("touchstart", handleActivity);

    return () => {
      window.removeEventListener("focus", handleActivity);
      window.removeEventListener("mousemove", handleActivity);
      window.removeEventListener("keydown", handleActivity);
      window.removeEventListener("touchstart", handleActivity);
    };
  }, [onActive]);
};

export default useUserActivity;
